"use client";
import React from "react";
import { Typography } from "@material-tailwind/react";
import ImageBackgroundCard from "@/components/image-bg-card";
import AboutusImageBackgroundCard from "./aboutus-image-back";

export function AboutUs() {
  return (
<div className="relative min-h-screen/2 w-full bg-[url('/image/dot-pattern.png')] bg-auto bg-left bg-no-repeat bg-grey-400">
  <div className="absolute inset-0 h-full w-full bg-teal-900 opacity-90"></div>
  <section className="w-full max-w-4xl mx-auto flex flex-col items-center px-3 py-10 animate-fade-down duration-500">
     
        <div className="container relative z-10 my-auto mx-auto grid place-items-center text-center">
          <Typography
            variant="h3"
            className="mb-0 mt-20 w-full text-center font-bold !text-white lg:w-10/12 animate-fade-down duration-500"
            color="white" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            About us
          </Typography>
    
          <Typography variant="h6" className="mb-10 max-w-lg mr-10 mt-5 w-full/2 text-center font-normal !text-white lg:w-10/10 animate-fade-down duration-500"  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          At Hope International, we are driven by a passion for enhancing the quality of life for elderly individuals and empowering caregivers to make a meaningful difference in their lives. 
          </Typography>
      

      </div>
      </section>
   
</div>


        
  
  );
  
}
